import React from 'react';
import * as LucideIcons from 'lucide-react';

interface IconProps {
  name: string;
  size?: number;
  className?: string;
  strokeWidth?: number;
  style?: React.CSSProperties;
}

const Icon: React.FC<IconProps> = ({ name, size = 20, className = '', strokeWidth = 2, style }) => {
  const LucideIcon = (LucideIcons as unknown as Record<string, React.ComponentType<{
    size?: number;
    className?: string;
    strokeWidth?: number;
    style?: React.CSSProperties;
  }>>)[name];
  if (!LucideIcon) return null;
  return <LucideIcon size={size} className={className} strokeWidth={strokeWidth} style={style} />;
};

export default Icon;
